import { render } from "./DocumentForm.vue?vue&type=template&id=144856f2&scoped=true"
import script from "./DocumentForm.vue?vue&type=script&lang=js"
export * from "./DocumentForm.vue?vue&type=script&lang=js"

import "./DocumentForm.vue?vue&type=style&index=0&id=144856f2&scoped=true&lang=css"

import exportComponent from "/Users/derem1991/workspace/newear/frontend/kajot/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-144856f2"]])

export default __exports__